
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/franchise-enquiry",
      function () {
        return require("private-next-pages/franchise-enquiry.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/franchise-enquiry"])
      });
    }
  